<template>
  <div>
      <Row><Button style="float: right; margin:-5px 0 6px 0" @click="openAddUserDrawer">Add User</Button></Row>
      <Table :columns="headers" :data="users" size="small" stripe @on-row-click=""  max-height="700">
          <template slot-scope="{ row }" slot="role">
              {{roleObj[row.role]}}
          </template>
          <template slot-scope="{ row }" slot="action">
              <Icon type="md-create" @click="openEditUserDrawer(row)"></Icon>
          </template>
      </Table>
    <add-user-drawer></add-user-drawer>
  </div>
</template>

<script>
import {SUBSCRIBE_USERS} from '../graphql/subscription/users'
import {GET_USERS} from '../graphql/queries/users'
import AddUserDrawer from '../components/AddUserDrawer'
import {convertArrToObj} from '../Constants/Constant'
    export default {
        apollo: {
            users: {
                query: GET_USERS,
                subscribeToMore: {
                    document: SUBSCRIBE_USERS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.users = subscriptionData.data.users;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.users = data.users;
                        this.rolesArr = data.roles;
                        this.roleObj = convertArrToObj(data.roles, 'id', 'name')
                    }
                }
            }
        },
        name: "Users",
        components: {AddUserDrawer},
        data: function(){
            return{
               users: [],
                rolesArr: [],
                headers: [
                    {title: 'Name', key: 'name'},
                    {title: 'Mobile', key: 'mobile'},
                    {title: 'Email', key: 'email'},
                    {title: 'Role', slot: 'role'},
                    {title: 'Action', slot: 'action'},
                ],
                addUserDrawer: false,
                roleObj: {},
                userData: ''
            }
        },
        methods: {
            openAddUserDrawer: function(){
                this.userData = '';
                this.addUserDrawer = true;
            },
            openEditUserDrawer: function(row){
                this.userData = row;
                this.addUserDrawer = true;
            }
        }
    }
</script>

<style scoped>

</style>